import React, { useEffect, useState } from 'react'
import { Fab, Grid, Typography, withStyles } from '@material-ui/core'

import classNames from 'classnames'
import { inject } from 'mobx-react'
import { observer } from 'mobx-react-lite'
import AddIcon from '../../../../components/Icon/AddIcon'
import InputForm from '../../../../components/Input/InputForm'
import { ReactSelect } from '../../../../components/Select/SelectSearch'
import { TextFieldSearch } from '../../../../components/TextField'
import { TypeModalEnumTGO } from '../../../../stores/TGO.store'
import Colors from '../../../../template/Colors'
import ContentProcedimentosSelecionados from './ContentProcedimentosSelecionados'
import { siglaFace } from '../../Tabs/Odontograma/Modal/Orcamento/Constatnts'

const statusNovoModelo = [
  { name: 'Ativo', value: true },
  { name: 'Inativo', value: false },
]

const InformationsGuiaTGO = observer(({ classes, TGOStore, formErrors }) => {
  const { readOnly, typeModal, objView } = TGOStore

  const [locais, setLocais] = useState([])

  const handleChangeNomeModelo = e => {
    const value = e.target.value
    TGOStore.nomeModelo = value
  }

  const handleChangeStatusNovoModelo = e => {
    TGOStore.changeFieldsStore({
      statusNovoModelo: e.value,
    })
  }

  const handleIndicacaoClinicaLoadOptions = async (search, loadedOptions, { page }) => {
    return handleLoadMoreOptions({
      search,
      loadedOptions,
      data: { page },
      method: 'findAllCid10Subcategoria',
    })
  }


  const handleCodigoTermoLoadOptions = async (search, loadedOptions, { page }) => {
    return handleLoadMoreOptionsDescricao({
      search: search,
      loadedOptions,
      data: { page },
      method: 'findAllTuss22ProcedimentoEventoSaude',
      field: 'codigoTermo',
    })
  }

  const handleDenteLoadOptions = async () => {
    const { codigoTermo } = TGOStore?.objView;

    let localOdontogramaIds = [];

    if (Array.isArray(codigoTermo?.localOdontograma)) {
      localOdontogramaIds = codigoTermo.localOdontograma.map(item => item?.id);
    } else if (codigoTermo?.localOdontograma?.id) {
      localOdontogramaIds = [codigoTermo.localOdontograma.id];
    }
    const hasIdDente = localOdontogramaIds?.includes(4);
    const localOdontogramaParam = hasIdDente ? [4] : localOdontogramaIds;

    const response = await TGOStore.findAllLocalOdontogramaGeral({
      localOdontograma: localOdontogramaParam,
    });

    setLocais(response);
  }

  const handleLoadMoreOptionsDescricao = async ({ search, data, method, sortDir, field }) => {
    const response = await TGOStore[method](
      {
        search,
        tabela: TGOStore.objView.tabela ? TGOStore.objView.tabela.value : null,
        pageableDTO: {
          pageNumber: data.page,
          sortDir,
        },
      },
      field
    )
    return {
      options: response.content,
      hasMore: !response.last,
      additional: {
        page: data.page + 1,
      },
    }
  }

  const handleLoadMoreOptions = async ({ search, data, method, field }) => {
    let searchDTO = {}

    if (data.searchDTO) {
      searchDTO = {
        ...data.searchDTO,
      }
    }
    const response = await TGOStore[method](
      {
        pageNumber: data.page,
        search,
        ...searchDTO,
      },
      field
    )
    return {
      options: response.content,
      hasMore: !response.last,
      additional: {
        page: data.page + 1,
      },
    }
  }

  const handleChange = (field, value) => {
    const truncate = (str, length = 255) => (str || '').substring(0, length);
  
    const handlers = {
      descricao: () => {
        if (value !== null) {
          objView.descricao = {
            value: truncate(value),
            label: truncate(value),
          };
        } else {
          objView.descricao = '';
          objView.codigoTermo = '';
        }
      },
  
      quantidadeSolicitada: () => {
        const quantidade = parseInt(value);
        if (quantidade > 0 && quantidade <= 999) {
          objView.quantidadeSolicitada = quantidade;
        }
      },

      quantidadeSolicitadaUnidadeServico: () => {
        const quantidade = parseInt(value);
        if (quantidade > 0 && quantidade <= 999) {
          objView.quantidadeSolicitadaUnidadeServico = quantidade;
        }
      },
  
      observacao: () => {
        objView.observacao = truncate(value);
      },
  
      tabela: () => {
        objView.tabela = value;
        objView.descricao = '';
        objView.codigoTermo = '';
      },
  
      codigo: () => {
        if (value !== null) {
          objView.descricao = {
            value: value.descricao,
            label: value.descricao,
          };
          objView.codigoTermo = value;
        } else {
          objView.descricao = '';
          objView.codigoTermo = '';
        }
      },
  
      indicacaoClinica: () => {
        objView.indicacaoClinica = {
          value: value?.id,
          label: value?.descricaoAbreviada,
        };
      },

      localOdontograma: () => {
        objView.localOdontograma = value;
      },
  
      face: () => {
        objView.face = value;
      },
    };
  

    if (handlers[field]) {
      handlers[field]();
    } else {
      objView[field] = value;
    }
  };

  const getErrorMessageFormTuss = (form) => {
    const {
      tabela,
      codigoTermo,
      descricao,
      quantidadeSolicitada,
      quantidadeSolicitadaUnidadeServico,
      localOdontograma,
      face,
    } = form;
  
    const isEmpty = (value) => value === null || value === undefined || value === "";
  
    const isValidQuantity = (value) => {
      const num = parseInt(value, 10);
      return !isNaN(num) && num >= 1 && num <= 999;
    };
  
    if (isEmpty(tabela) || isEmpty(codigoTermo) || isEmpty(descricao)) {
      return "Selecione a guia de serviço TUSS";
    }
  
    if (!isValidQuantity(quantidadeSolicitada)) {
      return "A quantidade solicitada deve estar entre 1 e 999";
    }
  
    if (!isValidQuantity(quantidadeSolicitadaUnidadeServico)) {
      return "A quantidade solicitada por unidade de serviço deve estar entre 1 e 999";
    }
  
    if (isEmpty(localOdontograma)) {
      return "Selecione um local odontograma";
    }
  
    if (isEmpty(face)) {
      return "Selecione uma face";
    }
  
    return "";
  };

  const handleClickAdd = () => {
    const quantidadeSolicitada =
      parseInt(objView.quantidadeSolicitada, 10) || 0;
    const quantidadeSolicitadaUnidadeServico =
      parseInt(objView.quantidadeSolicitadaUnidadeServico, 10) || 0;
    const errors = getErrorMessageFormTuss(objView);

    if (!errors) {
      objView.guiaServicoTgoTussViews = [
        ...(objView.guiaServicoTgoTussViews || []),
        {
          quantidadeSolicitada,
          quantidadeSolicitadaUnidadeServico,
          face: objView.face,
          localOdontograma: objView.localOdontograma,
          tussView: {
            tabela: objView.tabela.value,
            codigoTermo: objView.codigoTermo.value,
            descricao: objView.descricao.value,
          },
        },
      ];

      objView.codigoTermo = "";
      objView.quantidadeSolicitadaUnidadeServico = 1;
      objView.quantidadeSolicitada = 1;
      objView.localOdontograma = "";
      objView.face = "";
    } else {
      TGOStore.openNotification(errors, "error");
    }
  };

  useEffect(() => {
    if (TGOStore.objView.codigoTermo) {
      handleDenteLoadOptions();
    }
  }, [TGOStore.objView.codigoTermo]);

  useEffect(() => {
    if (locais.length && objView.localTipoId) {
      const selected = locais.find(item => item?.id === objView.localTipoId);
      if (selected) {
        TGOStore.objView.localOdontograma = selected;
      }
    }
  }, [locais, objView.localTipoId]);

  return (
    <>
      <Grid container className={classes.headerContent}>
        {typeModal !== TypeModalEnumTGO.TGO_MODAL && (
          <Grid className={classes.obsStatus}>
            <Grid item xs={8} className={classes.input}>
              <Typography color='primary' component='label' className={classes.label}>
                Nome do modelo:
              </Typography>
              {!readOnly && (
                <InputForm
                  id="prt-gtg-inp-nom"
                  alternativeInputClass={classes.inputObservacoes}
                  className={classNames([
                    classes.inputObs,
                    formErrors.nome ? classes.inputError : null,
                  ])}
                  placeholder=''
                  value={TGOStore.nomeModelo}
                  onChange={handleChangeNomeModelo}
                />
              )}
            </Grid>
            <Grid item xs={4}>
              <div className={classes.input}>
                <Typography color='primary' component='label' className={classes.label}>
                  Status:
                </Typography>
                <ReactSelect
                  id="prt-gtg-sel-sts"
                  className={classes.selectStatus}
                  name='status'
                  placeholder='Status'
                  value={TGOStore.statusNovoModelo ? statusNovoModelo[0] : statusNovoModelo[1]}
                  onChange={handleChangeStatusNovoModelo}
                  options={statusNovoModelo || []}
                  getOptionLabel={option => option.name}
                  getOptionValue={option => option.value}
                />
              </div>
            </Grid>
          </Grid>
        )}

        <Grid item xs={12}>
          <div className={classes.input}>
            <Typography color='primary' component='label' className={classes.label}>
              Indicação Clínica:
            </Typography>
            {readOnly && (
              <Typography color='inherit' component='label'>
                {objView.indicacaoClinica?.label || ''}
              </Typography>
            )}
            {!readOnly && (
              <TextFieldSearch
                id="prt-gtg-sel-inc"
                placeholder=''
                classNotched={classes.notchedOutline}
                classInput={classNames(formErrors.indicacaoClinica ? classes.inputError : null)}
                loadOptions={handleIndicacaoClinicaLoadOptions}
                withPaginate
                value={objView.indicacaoClinica}
                onChange={e => handleChange('indicacaoClinica', e)}
                debounceTimeout={300}
                additional={{
                  page: 0,
                }}
              />
            )}
          </div>
        </Grid>

        <Grid item xs={12}>
          <div className={classes.input}>
            <Typography color='primary' component='label' className={classes.label}>
              Observações/ Justificativa:
            </Typography>
            {readOnly && (
              <Typography color='inherit' component='label'>
                {objView.observacao || ' - '}
              </Typography>
            )}
            {!readOnly && (
              <InputForm
                id="prt-gtg-inp-obs"
                alternativeInputClass={classes.inputObservacoes}
                className={classes.inputObs}
                placeholder=''
                value={objView.observacao}
                onChange={e => handleChange('observacao', e.target.value)}
              />
            )}
          </div>
        </Grid>

        {!readOnly && (
          <>
            <Grid item xs={3}>
              <div className={classes.input}>
                <Typography color='primary' component='label' className={classes.label}>
                  Tabela:
                </Typography>
                <ReactSelect
                  id="prt-gtg-sel-tab"
                  className={classes.selectStatus}
                  placeholder='Selecione'
                  name='tabela'
                  value={objView.tabela}
                  onChange={e => handleChange('tabela', e)}
                  options={[objView.tabela]}
                  getOptionLabel={option => option?.label}
                  getOptionValue={option => option?.value}
                />
              </div>
            </Grid>
            <Grid item xs={6}>
              <div className={classes.input}>
                <Typography color='primary' component='label' className={classes.label}>
                  Código e descrição tuss:
                </Typography>
                <TextFieldSearch
                  id="prt-gtg-sel-cod"
                  placeholder=''
                  classNotched={classes.notchedOutline}
                  loadOptions={handleCodigoTermoLoadOptions}
                  withPaginate
                  value={objView.codigoTermo}
                  onChange={e => handleChange('codigo', e)}
                  debounceTimeout={300}
                  additional={{
                    page: 0,
                  }}
                />
              </div>
            </Grid>
            <Grid item xs={3}>
              <div className={classes.input}>
                <Typography color='primary' component='label' className={classes.label}>
                  Dente/Região:
                </Typography>
                <ReactSelect
                  id="prt-gtg-sel-den"
                  value={objView.localOdontograma}
                  className={classes.selectStatus}
                  onChange={e => handleChange('localOdontograma', e)}
                  options={locais}
                  menuPlacement={"auto"}
                  disabled={!objView.codigoTermo}
                  getOptionLabel={(option) =>{
                    if(option?.label) return option.label
                    return option.local === 4 ? `Dente ${option.codigo}` : option.descricao
                  }}
                  getOptionValue={(option) => option?.id ?? option?.value}
                />
              </div>
            </Grid>
            <Grid item xs={4}>
              <div className={classes.input}>
                <Typography color='primary' component='label' className={classes.label}>
                  Face:
                </Typography>
                <ReactSelect
                  id="prt-gtg-sel-fac"
                  className={classes.selectStatus}
                  placeholder='Selecione'
                  value={objView.face}
                  onChange={e => handleChange('face', e)}
                  options={siglaFace}
                  isClearable
                  getOptionLabel={option => option.label}
                  getOptionValue={option => option.value}
                />
              </div>
            </Grid>
            <Grid item xs={2}>
              <div className={classes.input}>
                <Typography color='primary' component='label' className={classes.label}>
                  Qtde US.:
                </Typography>
                <InputForm
                  id="prt-gtg-inp-qus"
                  alternativeInputClass={classes.inputQtd}
                  type='number'
                  placeholder=''
                  value={objView.quantidadeSolicitadaUnidadeServico}
                  onChange={e => handleChange('quantidadeSolicitadaUnidadeServico', e.target.value)}
                />
              </div>
            </Grid>
            <Grid item xs={2}>
              <div className={classes.input}>
                <Typography color='primary' component='label' className={classes.label}>
                  Qtde.:
                </Typography>
                <InputForm
                  id="prt-gtg-inp-qtd"
                  alternativeInputClass={classes.inputQtd}
                  type='number'
                  placeholder=''
                  value={objView.quantidadeSolicitada}
                  onChange={e => handleChange('quantidadeSolicitada', e.target.value)}
                />
              </div>
            </Grid>
            <Grid item xs={1}>
              <div className={classes.buttonAction}>
                <Fab
                  id="prt-gtg-btn-add"
                  className={classes.buttonIcon}
                  onClick={handleClickAdd}
                  color='primary'
                >
                  <AddIcon />
                </Fab>
              </div>
            </Grid>
          </>
        )}
      </Grid>
      <ContentProcedimentosSelecionados />
    </>
  )
})

const styles = {
  input: {
    marginLeft: 5,
    marginRight: 5,
    marginBottom: 4,
  },
  label: {
    fontFamily: 'Poppins !important',
    fontWeight: 'bold',
  },
  obsStatus: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
  },
  selectStatus: {
    width: '100%',
  },
  headerContent: {
    padding: '8px 0px',
    background: '#fff',
  },
  classIcons: {
    fontSize: 24,
  },
  notchedOutline: {
    border: '0',
  },
  inputObservacoes: {
    fontFamily: 'Poppins!important',
    fontSize: '14px',
    minHeight: '6px',
    height: '18px',
    color: Colors.commons.fontColor,
    backgroundColor: Colors.commons.gray2,
    margin: '0 0 0 0',
    padding: '9px 0px 5px 10px',
    borderRadius: '8px',
    border: '0.5px solid rgba(220, 220, 220, 0.2)',
    width: '100%',
  },
  inputObs: {
    width: '100%',
  },
  inputQtd: {
    fontSize: '14px',
    minHeight: '6px',
    height: '18px',
    color: Colors.commons.fontColor,
    backgroundColor: Colors.commons.gray2,
    margin: '0 0 0 0',
    padding: '9px 0px 5px 10px',
    border: '0.5px solid rgba(220, 220, 220, 0.2)',
    borderRadius: '8px',
  },
  inputError: {
    border: 'solid 1px red',
    borderRadius: '8px',
  },
  buttonAction: {
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonIcon: {
    width: '30px !important',
    height: '30px !important',
    minHeight: 'initial !important',
  },
}

const InformationsGuiaTGOWithStyles = withStyles(styles)(InformationsGuiaTGO)
export default inject('TGOStore')(InformationsGuiaTGOWithStyles)
